export default __webpack_public_path__ + "static/media/friends-around-the-block.5e8438a7.jpg";